"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevels = void 0;
exports.LogLevels = {
    Error: 4,
    Info: 1,
    Log: 2,
    Silent: 5,
    Trace: 0,
    Warn: 3,
};
//# sourceMappingURL=logger.js.map